export * from 'store/actions.js';
// import * as base from 'store/actions.js';

// Camera access
export const CAMERA_ACCESS_GRANTED		= 'CAMERA_ACCESS_GRANTED';
export const CAMERA_ACCESS_DENIED		= 'CAMERA_ACCESS_DENIED';

// AR model
export const AR_MODEL_LOADED			= 'AR_MODEL_LOADED';
export const AR_MODEL_VISIBILITY		= 'AR_MODEL_VISIBILITY';

// Not supported error
export const SHOW_NOT_SUPPORTED_ERROR	= 'SHOW_NOT_SUPPORTED_ERROR';
export const HIDE_NOT_SUPPORTED_ERROR	= 'HIDE_NOT_SUPPORTED_ERROR';

// Tracking
export const TRACK_MODEL_VIEWER_LOAD_START	= 'TRACK_MODEL_VIEWER_LOAD_START';
export const TRACK_MODEL_VIEWER_PROGRESS	= 'TRACK_MODEL_VIEWER_PROGRESS';
export const TRACK_MODEL_VIEWER_LOADED		= 'TRACK_MODEL_VIEWER_LOADED';